import CarPeritajeReportEntity from "../../../domain/entities/CarPeritajeReportEntity";

/**
 * Ruta de la ficha del vehículo. Replica `getUrlCar` (presentation/utils/Contants) para que el
 * enlace del reporte sea el mismo que abre el sitio desde una tarjeta.
 */
const detailPath = (type: string, name: string, id: string): string =>
    `/compra-tu-carro/${type}/${name}/${id}`.replace(/ /g, "-").toLowerCase();

/** Mapea un vehículo de `/v2/filter-cars/` a una fila del reporte, aún sin resolver el peritaje. */
const fromJson = (json: any): CarPeritajeReportEntity => {
    const id = String(json?.id ?? "");
    const type = json?.type?.type ?? "";
    const name = json?.car ?? "";

    return {
        id,
        plate: (json?.tuition ?? "").toString().trim(),
        name,
        brand: json?.brand_car?.brand ?? "",
        line: json?.model?.model ?? "",
        version: json?.version?.version ?? "",
        year: String(json?.year ?? ""),
        type,
        sede: json?.sede_car?.name ?? "",
        tag: json?.tag_car?.tag ?? "",
        mileage: Number(json?.mileage ?? 0),
        price: Number(json?.price ?? 0),
        hasAutomasPdf: Boolean(json?.automas_pdf),
        hasColserautoId: Boolean((json?.id_colserauto ?? "").toString().trim()),
        hasAutomasApi: false,
        hasColserautoApi: false,
        source: null,
        checkFailed: false,
        detailPath: detailPath(type, name, id),
    };
};

export default { fromJson };
